import Query from "../utils/graphqlQueryBuilder";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { EditProfileConstants } from "../constants/editProfile.constants";
import { doGraphQLQuery, handleFailure } from "./graphql.saga";
import {
    saveProfileFailure,
    saveProfileSuccess
} from "../actions/editProfile.actions";
import { resetFeed } from "../actions/feed.actions";

export function* saveProfile() {
    yield takeEvery(EditProfileConstants.SAVE_PROFILE, doSaveProfile);
}

function* doSaveProfile() {
    try {
        let {
            displayName,
            languages,
            emailNotifications
        } = yield select(
            ({
                editProfile: { displayName, languages, emailNotifications }
            }) => ({
                displayName,
                languages,
                emailNotifications
            })
        );

        displayName = displayName.substr(0, 100);
        const updateUserMutation = new Query("mutation").find(
            new Query("updateUser", {
                languages: languages.toJS(),
                displayName,
                emailNotifications
            }).find(["id"])
        );

        const { updateUser: { id } } = yield call(
            doGraphQLQuery,
            updateUserMutation.toString()
        );

        yield put(
            saveProfileSuccess({
                id,
                displayName,
                emailNotifications,
                languages
            })
        );
        yield put(resetFeed());
    } catch (e) {
        yield call(handleFailure, e, saveProfileFailure);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/editProfile.saga.js